import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import BaseTableView from 'properties/BaseTableView.js'
import { View } from 'backbone';
import Template from 'properties/main/drop-down.ejs';
import PredefinedListsModal from 'common-views/PredefinedListsModalView.js';
import PredefinedListsService from 'PredefinedListsService';
import RestService from 'RestService';
import NotificationService  from 'NotificationService';
import listService          from 'ListService.js';
import eventBus             from 'EventBus.js';
import util                 from 'util/Util.js';


class MainDropDownView extends BaseTableView {



    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.config = opts.config || {};

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "change input[type=checkbox]" : "itemCheck",
            "click .itemList" : "itemPredefinedList"
        };

        this.model.set({
            colModel: [
                {
                    name: 'caption',
                    index: 'caption',
                    width: 100,
                    editable: true
                },
                {
                    name: 'value',
                    index: 'value',
                    width: 100,
                    editable: true
                },
                {
                    name: 'selected',
                    index: 'selected',
                    width: 100,
                    edittype: 'checkbox',
                    editoptions: { value:"selected" },
                    formatter: "checkbox",
                    formatoptions: { disabled: false}
                }
            ],
            colNames: ['Caption', 'Value', 'Selected']
        }, {silent: true});

        if (this.model.get('gridData').length === 0) {
            if (listService.selectedCount === 1) {
                this.loadDataFromProperty();
            }
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    loadDataFromProperty() {
        const prop = this.model.get('Property');
        let captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        let values = _.find(prop, function(obj) { return obj._id === 'values' });

        if (!captions.Item) { captions.Item = []; }
        if (!values.Item) { values.Item = []; }

        const index = this.model.get('selectedIndex');
        // let gridData = this.model.get('gridData');
        let gridData = [];


        if (Array.isArray(captions.Item)) {
            for (let i = 0; i < captions.Item.length; i++) {

                let newRow = {
                    'caption': captions.Item[i]._value,
                    'value': values.Item[i]._value ,
                    'selected':  index === i.toString() ? 'selected' : ''
                };

                gridData.push(newRow);
            }
        } else {
            let newRow = {
                'caption': captions.Item._value,
                'value': values.Item._value ,
                'selected': ''
            };

            gridData.push(newRow);

            // enforce array type
            const newItem = {_value: captions.Item._value};
            captions.Item = [newItem];

            const newValueItem = {_value: values.Item._value};
            values.Item = [newValueItem];
        }

        this.model.set('gridData', gridData, {silent: true});

    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        if (listService.selectedCount > 1) {
            var gridData, newRow;
            listService.selected.map((view, key)=>{
                this.model = view.model;

                gridData = this.model.get('gridData');
                newRow = {
                    'caption':'Item ' + (gridData.length+1) ,
                    'value': (gridData.length+1) ,
                    'selected':  ''
                };

                gridData.push(newRow);
        
                let captions = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'captions' });
                let values = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'values' });
        
                captions.Item.push({ _value: 'Item ' + (gridData.length+1) } );
                values.Item.push({ _value: (gridData.length+1) } );
        
                this.model.set('gridData', gridData, constants.MODEL_SILENT);
            });
            this.model.trigger('change');
            $(constants.PROP_MAIN_TABLE).addRowData((gridData.length + 1), newRow);
        } else {
            var gridData = this.model.get('gridData');
            var newRow = {
                'caption':'Item ' + (gridData.length+1) ,
                'value': (gridData.length+1) ,
                'selected':  ''
            };
            $(constants.PROP_MAIN_TABLE).addRowData((gridData.length + 1), newRow);
    
            gridData.push(newRow);
    
            let captions = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'captions' });
            let values = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'values' });
    
            captions.Item.push({ _value: 'Item ' + (gridData.length+1) } );
            values.Item.push({ _value: (gridData.length+1) } );
    
            this.model.set('gridData', gridData);
            this.model.trigger('change');
        }
        eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
    }

    itemRemove(){
        if (listService.selectedCount > 1) {
            listService.selected.map((view, key)=>{
                this.model = view.model;
                const rowid = this.model.get('rowid');
                const prop = this.model.get('Property');
                let captions = _.find(prop, function(obj) { return obj._id === 'captions' });
                let values = _.find(prop, function(obj) { return obj._id === 'values' });
                const deleteIndex = rowid === undefined ? captions.Item.length -1: rowid;
                
                captions.Item.splice(deleteIndex,1);
                values.Item.splice(deleteIndex,1);
            });
            super.itemRemove();
        } else {
            const rowid = this.model.get('rowid');
            const prop = this.model.get('Property');
            let captions = _.find(prop, function(obj) { return obj._id === 'captions' });
            let values = _.find(prop, function(obj) { return obj._id === 'values' });
            const deleteIndex = rowid === undefined ? captions.Item.length -1: rowid;
            const selectedIndex = this.model.get('selectedIndex');
            
            captions.Item.splice(deleteIndex,1);
            values.Item.splice(deleteIndex,1);

            if (deleteIndex == selectedIndex || captions.Item.length === 0) {
                this.model.set('selectedIndex', -1, {silent:true});
            }
    
            super.itemRemove();
        }
        eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);

    }

    fillGrid(elements){
        let gridData=this.model.get('gridData');
        gridData=[];
        Object.keys(elements).forEach((key)=>{
            var newRow = {
                'caption':elements[key] ,
                'value': key ,
                'selected':  ''
            };
            //$(constants.PROP_MAIN_TABLE).addRowData((gridData.length + 1), newRow);
            gridData.push(newRow);
        });
        this.model.set('gridData', gridData);
    }

    fillGridFromCustomList(elements){
      let gridData=this.model.get('gridData');
      gridData=[];
      elements.forEach((list)=>{
        var newRow = {
           'caption':list["@caption"] ,
           'value': list["@value"],
           'selected':  ''
         };
         gridData.push(newRow);
       });
       this.model.set('gridData', gridData);
     }

    itemPredefinedList(event){
        var predModal = new PredefinedListsModal({model: this.model});
        predModal.render().then((selected)=>{
            let items;
            $(constants.PROP_MAIN_TABLE).clearGridData();
            switch (selected){
                case 'countries':
                    items=PredefinedListsService.getCountries();
                    this.fillGrid(items);
                    break;
                case 'states':
                    items=PredefinedListsService.getUSStates();
                    this.fillGrid(items);
                    break;
                case 'provinces':
                    items=PredefinedListsService.getCanadianProvinces();
                    this.fillGrid(items);
                    break;
              default:
                    this.fillListFromCustomList(selected)
            }
        });
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        $("#" + iRow + "_" + cellName).on('blur', function () {
            $(self.gridEl).saveCell(iRow, iCol);
        });
    }

    fillListFromCustomList(selected){
      RestService.getCustomList(selected).then((customLists)=>{
          console.log('customLists',customLists);
        let customListsArray=customLists instanceof Array ? customLists : [customLists];
        this.fillGridFromCustomList(customListsArray);
      }).catch((err=>{
        console.log('Error retrieving custom list items ',err);
        NotificationService.error('Error retrieving custom list items '+err.MESSAGE);
      }));
    }

}

export default MainDropDownView;
